import 'i18next';
import { Type } from 'class-transformer';
import { IsInt, IsNotEmpty, IsNumber, Max, Min } from 'class-validator';

import { t } from '@app-velocity/i18n';

export class ReportConfigDto {
  @IsNotEmpty({
    message: t('prototypes:validation.success_rate_cannot_be_empty'),
  })
  @Type(() => Number)
  @IsNumber()
  @Min(0, {
    message: t('prototypes:validation.success_rate_too_low', {
      min: 0,
    }),
  })
  @Max(100, {
    message: t('prototypes:validation.success_rate_too_high', {
      max: 100,
    }),
  })
  successRate = 50;

  @IsNotEmpty({
    message: t('prototypes:validation.drop_off_rate_cannot_be_empty'),
  })
  @Type(() => Number)
  @IsInt()
  @Min(0, {
    message: t('prototypes:validation.drop_off_rate_too_low', {
      min: 0,
    }),
  })
  @Max(100, {
    message: t('prototypes:validation.drop_off_rate_too_high', {
      max: 100,
    }),
  })
  dropOffRate = 20;

  @IsNotEmpty({
    message: t('prototypes:validation.missclick_rate_cannot_be_empty'),
  })
  @Type(() => Number)
  @IsInt()
  @Min(0, {
    message: t('prototypes:validation.missclick_rate_too_low', {
      min: 0,
    }),
  })
  @Max(100, {
    message: t('prototypes:validation.missclick_rate_too_high', {
      max: 100,
    }),
  })
  missclickRate = 20;

  @IsNotEmpty({
    message: t('prototypes:validation.time_to_success_cannot_be_empty'),
  })
  @Type(() => Number)
  @IsInt()
  @Min(0, {
    message: t('prototypes:validation.time_to_success_too_low', {
      min: 0,
    }),
  })
  @Max(60000, {
    message: t('prototypes:validation.time_to_success_too_high', {
      max: 60000,
    }),
  })
  timeToSuccess = 40;

  @IsNotEmpty({
    message: t('prototypes:validation.min_human_participants_cannot_be_empty'),
  })
  @Type(() => Number)
  @IsInt()
  @Min(0, {
    message: t('prototypes:validation.min_human_participants_too_low', {
      min: 0,
    }),
  })
  @Max(60000, {
    message: t('prototypes:validation.min_human_participants_too_high', {
      max: 60000,
    }),
  })
  minimumHumanParticipants = 0;

  @IsNotEmpty({
    message: t('prototypes:validation.min_ai_participants_cannot_be_empty'),
  })
  @Type(() => Number)
  @IsInt()
  @Min(0, {
    message: t('prototypes:validation.min_ai_participants_too_low', {
      min: 0,
    }),
  })
  @Max(60000, {
    message: t('prototypes:validation.min_ai_participants_too_high', {
      max: 60000,
    }),
  })
  minimumAiParticipants = 10;
}
